import React, { useMemo, useState } from "react";
import FrontendConfig from "../assets/config.js";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

function ReportSecret({ toggleShowModal, toggleShowSuccessModal }) {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [reason, setReason] = useState("INAPPROPRIATE_CONTENT");
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [submitted, setSubmitted] = useState(false);

  // Read query params from /reportsecret?secretId=...&token=...
  const query = useMemo(() => new URLSearchParams(window.location.hash.split("?")[1] || ""), []);
  const secretId = query.get("secretId") || "";
  const reportToken = query.get("token") || "";

  async function submitReport() {
    if (submitting) return;

    if (!secretId || !reportToken) {
      toggleShowModal(
        <>
          <div>
            <i className="fas fa-3x fa-exclamation-triangle"></i>
          </div>
          <p>Secret report link is invalid.</p>
        </>
      );
      return;
    }

    if (!comment.trim()) {
      toggleShowModal(
        <>
          <div>
            <i className="fas fa-3x fa-exclamation-triangle"></i>
          </div>
          <p>Please enter a comment before submitting the report.</p>
        </>
      );
      return;
    }

    try {
      setSubmitting(true);

      // Initializing captchaToken
      let captchaToken = null;

      if (executeRecaptcha) {
        try {
          captchaToken = await executeRecaptcha("reportsecret");
        } catch (err) {
          console.log("recaptcha error:", err);
        }
      }

      const response = await fetch(FrontendConfig.api_endpoint + "/incident", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Captcha-Token": captchaToken
        },
        body: JSON.stringify({
          mode: "SECRET_CONTENT",
          reason: reason,
          comment: comment,
          secret: {
            secretId: secretId,
            reportToken: reportToken
          }
        })
      });

      const responseData = await response.json();

      if (response.ok && responseData.status === "Success") {
        setSubmitted(true);
        setComment("");
        setReason("INAPPROPRIATE_CONTENT");
        return;
      }

      toggleShowModal(
        <>
          <div>
            <i className="fas fa-3x fa-exclamation-triangle"></i>
          </div>
          <p>{responseData.message || "Unable to submit the report."}</p>
        </>
      );
    } catch (error) {
      toggleShowModal(
        <>
          <div>
            <i className="fas fa-3x fa-exclamation-triangle"></i>
          </div>
          <p>Unable to submit the report.</p>
        </>
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="content">
      <div className="row">
        <div className="col-lg-12 col-md-10 col-sm-11 ml-auto mr-auto">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "18px", overflow: "hidden" }}
          >
            {!submitted && (
              <div className="card-header pb-0" style={{ borderBottom: "none" }}>
                <h4 className="title text-center mb-2">Report secret content</h4>
                <p className="text-center text-muted mb-10">
                  Tell us why you are reporting this secret.
                </p>
              </div>
            )}

            <div className="card-body px-md-5 py-4">

            {submitted ? (
              <div className="text-center py-4">
                <div className="mb-3">
                  <i className="fas fa-3x fa-check-circle text-success"></i>
                </div>
                <h4 className="mb-2">Report submitted</h4>
                <p className="text-muted mb-2">
                  Your report was submitted successfully.
                </p>
                <p className="text-muted mb-0">
                  You can close this tab now.
                </p>
              </div>
            ) : (
              <>
                <div className="text-center mb-4">
                  <div className="mb-3">
                    <i className="fas fa-flag fa-2x text-danger"></i>
                  </div>
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="reason" className="font-weight-bold">
                    Reason
                  </label>
                  <select
                    id="reason"
                    className="form-control"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    disabled={submitted || submitting}
                    style={{ borderRadius: "12px" }}
                  >
                    <option value="THREAT">Threat</option>
                    <option value="HARASSMENT">Harassment</option>
                    <option value="INAPPROPRIATE_CONTENT">Inappropriate content</option>
                    <option value="SPAM">Spam</option>
                    <option value="PHISHING">Phishing</option>
                    <option value="IMPERSONATION">Impersonation</option>
                    <option value="ILLEGAL_CONTENT">Illegal content</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>

                <div className="form-group mb-4">
                  <label htmlFor="comment" className="font-weight-bold">
                    Comment
                  </label>
                  <textarea
                    id="comment"
                    className="form-control"
                    disabled={submitted || submitting}
                    rows="4"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Describe why you are reporting this secret."
                    maxLength="500"
                    style={{ resize: "vertical", borderRadius: "12px" }}
                  />
                  <small className="form-text text-muted">
                    Please include as much detail as possible.
                  </small>
                  <div className="text-right text-muted mt-2">
                    {comment.length}/500
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button
                    className="btn btn-danger btn-round px-5"
                    type="button"
                    onClick={submitReport}
                    disabled={submitted || submitting}
                  >
                    {submitting ? "Submitting..." : "Submit report"}
                  </button>
                </div>
              </>
            )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportSecret;